import { useMemo } from "react";
import {
  lerConfiguracoesSistemaPublicas,
  useConfiguracoesSistemaPublicas,
  type ConfiguracoesSistemaPublicas,
} from "./configuracoesSistema";

/** APIs liberadas empresa a empresa na aba Configurações → Telas por empresa. */
export type ChaveRecursoApi =
  | "tef"
  | "fiscal"
  | "email"
  | "whatsapp"
  | "ia"
  | "conciliador";

export interface EstadoRecursoApi {
  /** API desligada para a empresa: o botão/tela não deve nem ser renderizado. */
  visivel: boolean;
  /** API ligada e integração contratada/ativa: o botão pode ser clicado. */
  habilitado: boolean;
  /** Açúcar para `disabled` de botões — visível porém sem integração ativa. */
  bloqueado: boolean;
}

export type RecursosApi = Record<ChaveRecursoApi, EstadoRecursoApi>;

function estado(visivel: boolean, integracaoAtiva: boolean): EstadoRecursoApi {
  const habilitado = visivel && integracaoAtiva;
  return { visivel, habilitado, bloqueado: !habilitado };
}

/**
 * Regra única de exibição das APIs: desligada some da interface; ligada aparece,
 * mas só fica clicável quando a integração correspondente estiver ativa (TEF e
 * Fiscal por empresa, e-mail e IA na configuração global). No WhatsApp QR, a
 * conexão da sessão é validada pelo backend no momento de cada envio.
 */
export function obterRecursosApi(
  configuracoes: ConfiguracoesSistemaPublicas = lerConfiguracoesSistemaPublicas()
): RecursosApi {
  return {
    tef: estado(configuracoes.tefMenu, configuracoes.tefIntegracao),
    fiscal: estado(configuracoes.fiscalMenu, configuracoes.fiscalIntegracao),
    email: estado(configuracoes.emailApi, configuracoes.emailIntegracao),
    whatsapp: estado(configuracoes.whatsappApi, configuracoes.whatsappApi),
    ia: estado(configuracoes.iaApi, configuracoes.iaAtiva),
    conciliador: estado(configuracoes.conciliadorApi, configuracoes.conciliadorIntegracao),
  };
}

export function useRecursosApi(): RecursosApi {
  const configuracoes = useConfiguracoesSistemaPublicas();
  return useMemo(() => obterRecursosApi(configuracoes), [configuracoes]);
}
